export default {
	title: 'Informe de Diagnóstico',
	selectOrg: 'Seleccionar Organización',
	selectAll: 'Seleccionar Todo',
	selectedItems: 'Seleccionados {count} elementos',
	batchDelete: 'Eliminar en Lote',
	batchDeleteWithCount: 'Eliminar en Lote ({count})',
	sendEmail: 'Enviar Correo',
	sendEmailWithCount: 'Enviar Correo ({count})',
	noData: {
		title: 'Sin Informes de Diagnóstico',
		description: 'No se encontraron datos de informes de diagnóstico relevantes'
	},
	reportCard: {
		coverAlt: 'Portada del Informe de Diagnóstico',
		maker: 'Autor',
		updateTime: 'Tiempo de Actualización'
	},
	actions: {
		check: 'Verificar',
		download: 'Descargar',
		modify: 'Modificar',
		delete: 'Eliminar',
		sendEmail: 'Enviar Correo',
		batchDelete: 'Eliminar en Lote'
	},
	configDialog: {
		title: 'Verificación de Informe de Diagnóstico',
		reportConfig: 'Verificación de Informe',
		warnConfig: 'Verificación de Alarma',
		projectName: 'Nombre del Proyecto',
		deviceName: 'Nombre del Dispositivo',
		reportTime: 'Tiempo de Generación del Informe',
		author: 'Autor',
		warnItem: 'Elemento de Alarma',
		delete: 'Eliminar',
		faultLocation: 'Ubicación de la Falla',
		faultType: 'Tipo de Falla',
		selectFaultType: 'Por favor seleccione el tipo de falla',
		alarmLevel: 'Nivel de Alarma',
		selectAlarmLevel: 'Por favor seleccione el nivel de alarma',
		alarmCount: 'Cantidad de Alarmas',
		diagnosisAnalysis: 'Análisis de Diagnóstico',
		enterDiagnosisAnalysis: 'Por favor ingrese el análisis de diagnóstico',
		relatedAtlas: 'Atlas Relacionado',
		addAtlas: 'Agregar Atlas',
		diagnosisConclusion: 'Conclusión del Diagnóstico',
		enterDiagnosisConclusion: 'Por favor ingrese la conclusión del diagnóstico',
		maintenanceSuggestion: 'Sugerencia de Mantenimiento',
		enterMaintenanceSuggestion: 'Por favor ingrese la sugerencia de mantenimiento',
		alarmStartTime: 'Tiempo de Inicio de la Alarma',
		alarmEndTime: 'Tiempo de Fin de la Alarma',
		selectDateTime: 'Seleccionar fecha y hora',
		regenerate: 'Regenerar'
	},
	emailDialog: {
		title: 'Enviar Correo',
		ccPerson: 'Persona CC',
		selectCcPerson: 'Por favor seleccione la persona CC',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	messages: {
		selectReportWarning: 'Por favor seleccione informe de diagnóstico',
		selectCcPersonWarning: 'Por favor seleccione la persona CC',
		sendSuccess: 'Enviado exitosamente',
		deleteConfirm: '¿Está seguro de eliminar los {count} elementos seleccionados?',
		deleteSuccess: 'Eliminado exitosamente',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		configSuccess: 'Informe de diagnóstico configurado exitosamente',
		uploadImageError: '¡Solo se pueden cargar archivos de imagen!',
		uploadImageSizeError: '¡El tamaño de la imagen no puede superar 5MB!',
		selectedCount: '{count} elemento(s) seleccionado(s)',
		operateSuccess: 'Operación exitosa'
	},
	form: {
		fileName: 'Nombre del Informe',
		startTime: 'Tiempo de Inicio',
		endTime: 'Tiempo de Fin',
		reportTitle: 'Título del Informe',
		maker: 'Autor',
		orgId: 'Departamento',
		result: 'Resultado del Diagnóstico',
		fileViewInDoc: 'Ver en documento',
		diagnosticReport: 'Informe de Diagnóstico',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		add: 'Agregar',
		update: 'Actualizar'
	},
	table: {
		reportTitle: 'Título del Informe',
		diagnosticReport: 'Informe de Diagnóstico',
		maker: 'Autor',
		orgId: 'Departamento',
		result: 'Resultado del Diagnóstico',
		updateTime: 'Tiempo de Diagnóstico'
	}
}
